export interface Language {
  code: string;
  name: string;
  countryCode: string;
}

export const SUPPORTED_LANGUAGES: Language[] = [
  { code: 'af', name: 'Afrikaans', countryCode: 'za' },
  { code: 'sq', name: 'Albanian', countryCode: 'al' },
  { code: 'am', name: 'Amharic', countryCode: 'et' },
  { code: 'ar', name: 'Arabic', countryCode: 'sa' },
  { code: 'hy', name: 'Armenian', countryCode: 'am' },
  { code: 'az', name: 'Azerbaijani', countryCode: 'az' },
  { code: 'bn', name: 'Bengali', countryCode: 'bd' },
  { code: 'bs', name: 'Bosnian', countryCode: 'ba' },
  { code: 'bg', name: 'Bulgarian', countryCode: 'bg' },
  { code: 'ca', name: 'Catalan', countryCode: 'es' },
  { code: 'zh', name: 'Chinese (Simplified)', countryCode: 'cn' },
  { code: 'zh-TW', name: 'Chinese (Traditional)', countryCode: 'tw' },
  { code: 'hr', name: 'Croatian', countryCode: 'hr' },
  { code: 'cs', name: 'Czech', countryCode: 'cz' },
  { code: 'da', name: 'Danish', countryCode: 'dk' },
  { code: 'fa-AF', name: 'Dari', countryCode: 'af' },
  { code: 'nl', name: 'Dutch', countryCode: 'nl' },
  { code: 'en', name: 'English', countryCode: 'gb' },
  { code: 'et', name: 'Estonian', countryCode: 'ee' },
  { code: 'fa', name: 'Farsi (Persian)', countryCode: 'ir' },
  { code: 'tl', name: 'Filipino Tagalog', countryCode: 'ph' },
  { code: 'fi', name: 'Finnish', countryCode: 'fi' },
  { code: 'fr', name: 'French', countryCode: 'fr' },
  { code: 'fr-CA', name: 'French (Canada)', countryCode: 'ca' },
  { code: 'ka', name: 'Georgian', countryCode: 'ge' },
  { code: 'de', name: 'German', countryCode: 'de' },
  { code: 'el', name: 'Greek', countryCode: 'gr' },
  { code: 'gu', name: 'Gujarati', countryCode: 'in' },
  { code: 'ht', name: 'Haitian Creole', countryCode: 'ht' },
  { code: 'ha', name: 'Hausa', countryCode: 'ng' },
  { code: 'he', name: 'Hebrew', countryCode: 'il' },
  { code: 'hi', name: 'Hindi', countryCode: 'in' },
  { code: 'hu', name: 'Hungarian', countryCode: 'hu' },
  { code: 'is', name: 'Icelandic', countryCode: 'is' },
  { code: 'id', name: 'Indonesian', countryCode: 'id' },
  { code: 'ga', name: 'Irish', countryCode: 'ie' },
  { code: 'it', name: 'Italian', countryCode: 'it' },
  { code: 'ja', name: 'Japanese', countryCode: 'jp' },
  { code: 'kn', name: 'Kannada', countryCode: 'in' },
  { code: 'kk', name: 'Kazakh', countryCode: 'kz' },
  { code: 'ko', name: 'Korean', countryCode: 'kr' },
  { code: 'lv', name: 'Latvian', countryCode: 'lv' },
  { code: 'lt', name: 'Lithuanian', countryCode: 'lt' },
  { code: 'mk', name: 'Macedonian', countryCode: 'mk' },
  { code: 'ms', name: 'Malay', countryCode: 'my' },
  { code: 'ml', name: 'Malayalam', countryCode: 'in' },
  { code: 'mt', name: 'Maltese', countryCode: 'mt' },
  { code: 'mr', name: 'Marathi', countryCode: 'in' },
  { code: 'mn', name: 'Mongolian', countryCode: 'mn' },
  { code: 'no', name: 'Norwegian', countryCode: 'no' },
  { code: 'ps', name: 'Pashto', countryCode: 'af' },
  { code: 'pl', name: 'Polish', countryCode: 'pl' },
  { code: 'pt', name: 'Portuguese (Brazil)', countryCode: 'br' },
  { code: 'pt-PT', name: 'Portuguese (Portugal)', countryCode: 'pt' },
  { code: 'pa', name: 'Punjabi', countryCode: 'in' },
  { code: 'ro', name: 'Romanian', countryCode: 'ro' },
  { code: 'ru', name: 'Russian', countryCode: 'ru' },
  { code: 'sr', name: 'Serbian', countryCode: 'rs' },
  { code: 'si', name: 'Sinhala', countryCode: 'lk' },
  { code: 'sk', name: 'Slovak', countryCode: 'sk' },
  { code: 'sl', name: 'Slovenian', countryCode: 'si' },
  { code: 'so', name: 'Somali', countryCode: 'so' },
  { code: 'es', name: 'Spanish', countryCode: 'es' },
  { code: 'es-MX', name: 'Spanish (Mexico)', countryCode: 'mx' },
  { code: 'sw', name: 'Swahili', countryCode: 'tz' },
  { code: 'sv', name: 'Swedish', countryCode: 'se' },
  { code: 'ta', name: 'Tamil', countryCode: 'in' },
  { code: 'te', name: 'Telugu', countryCode: 'in' },
  { code: 'th', name: 'Thai', countryCode: 'th' },
  { code: 'tr', name: 'Turkish', countryCode: 'tr' },
  { code: 'uk', name: 'Ukrainian', countryCode: 'ua' },
  { code: 'ur', name: 'Urdu', countryCode: 'pk' },
  { code: 'uz', name: 'Uzbek', countryCode: 'uz' },
  { code: 'vi', name: 'Vietnamese', countryCode: 'vn' },
  { code: 'cy', name: 'Welsh', countryCode: 'gb-wls' }
];

export const DEFAULT_LANGUAGE = 'en';

export const getLanguageName = (code: string): string => {
  const language = SUPPORTED_LANGUAGES.find((lang) => lang.code === code);
  return language?.name || 'English';
};

export const getLanguageCountryCode = (code: string): string => {
  const language = SUPPORTED_LANGUAGES.find((lang) => lang.code === code);
  return language?.countryCode || 'gb';
};

export const getFlagUrl = (countryCode: string, width: number = 24): string => {
  return `https://flagcdn.com/w${width}/${countryCode}.png`;
};
